import { atom } from "recoil";

export const ShowAssetUploadState = atom<boolean>({
  key: "showAssetUploadState",
  default: false,
});
